var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Window',{attrs:{"ad_window_id":_vm.ad_window_id},model:{value:(_vm.record_id),callback:function ($$v) {_vm.record_id=$$v},expression:"record_id"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }